module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_8_A_3.6704270b.mp3";